import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3181b310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip-content" }
const _hoisted_2 = { class: "pre-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, { "show-after": 300 }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.parseContent), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.parseContent), 1)
    ]),
    _: 1
  }))
}